export class FileObject {
  constructor(file, promise) {
    this.file = file;
    this.name = this.file.name;
    this.size = this.file.size;
    this.type = this.file.type;
    this.url = null;

    this.updateUrl(this.file, promise);
  }

  updateUrl(file = this.file, promise) {
    const reader = new FileReader();
    // eslint-disable-next-line no-return-assign
    reader.onload = e => this.url = e.target.result;
    reader.readAsDataURL(file);
    promise(file)
  }
}

export function readFileAsync(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.onerror = reject;

    reader.readAsDataURL(file);
  })
}

export async function exportFileWithoutSave(resource, params, body) {
  const response = await resource.execute(params, body)
  const blob = await response.blob()
  const disposition = response.headers.get('Content-Disposition')
  const name = disposition.match(new RegExp('"([^;]*)"'))[1]

  return {
    url: window.URL.createObjectURL(blob),
    name,
  }
}